module.exports = __webpack_public_path__ + "static/media/Mobile.da654d99.svg";